import { render, staticRenderFns } from "./SlotFacilityRoleIDs.vue?vue&type=template&id=d10b55be&scoped=true&"
import script from "./SlotFacilityRoleIDs.vue?vue&type=script&lang=js&"
export * from "./SlotFacilityRoleIDs.vue?vue&type=script&lang=js&"
import style0 from "./SlotFacilityRoleIDs.vue?vue&type=style&index=0&id=d10b55be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10b55be",
  null
  
)

export default component.exports